import {
  faTrashCan,
  faClockRotateLeft,
} from "@fortawesome/pro-solid-svg-icons";
import type { BatchAction } from "@components/CatalogIndex";
import type { DocumentTemplateTab } from "../types";

export interface BatchActionHandlers {
  onDelete: () => void;
  onRestore: () => void;
}

export const buildDocumentTemplateBatchActions = (
  tab: DocumentTemplateTab,
  _selectedCount: number,
  handlers: BatchActionHandlers
): BatchAction[] => {
  if (tab === "archived") {
    return [
      {
        icon: faClockRotateLeft,
        label: "Restore",
        onClick: handlers.onRestore,
      },
    ];
  }
  return [
    {
      icon: faTrashCan,
      label: "Delete",
      onClick: handlers.onDelete,
      variant: "danger",
    },
  ];
};
